// Its own module so the image resolver (`imgProtector`, on every page) can read the
// API origin without importing the axios client in `http.ts`.
export const API_URL: string =
  (import.meta.env.VITE_API_URL as string | undefined) ?? "http://api.localhost";
